import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
  Label,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const AmortizationGapByInterestType = ({ data, palette, title }) => {
  const chartRef = useRef(null);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const customizeTooltip = (arg) => {
    const pointData = arg.point?.data || {};
    const amortizationGapTotal = pointData.amortizationGapTotal || 0;

    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${
            arg.argumentText
          }</div>
          <div><span style="font-weight: 600;">Amortization Gap</span>: ${formatter.format(
            amortizationGapTotal
          )}</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title={title || "Amortization Gap by Interest Type"}
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={data}
          id="interestTypeGapChart"
          ref={chartRef}
          palette={palette}
        >
          <Series
            valueField="amortizationGapTotal"
            argumentField="interestType"
            name="Amortization Gap"
            type="bar"
          />
          <ArgumentAxis>
            <Label
              wordWrap="normal"
              textOverflow="ellipsis"
              overlappingBehavior="rotate"
              rotationAngle={45}
            />
          </ArgumentAxis>
          <ValueAxis />
          <Legend visible={false} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            format="fixedPoint"
            precision={2}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default AmortizationGapByInterestType;
